import React, { useEffect } from 'react'
import { Table } from 'antd'
import { ColumnsType } from 'antd/es/table'
import { baseRoutineModel } from '../routineModel'
import { IRoutineDetail } from '../routineService'
import { DeleteOutlined, FormOutlined } from '@ant-design/icons'
import { Button } from 'antd/lib/radio'

export function DataTable() {
    const { dataSource, selectedRowKeys, pgCfg, loading, setEditCarVisible, loadData, setSelectedRowKeys, onDelete } = baseRoutineModel()

    useEffect(() => {
        loadData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const columns: ColumnsType<IRoutineDetail> = [
        {
            title: '序号',
            width: 60,
            align: 'center',
            render: (t, r, i) => i + 1,
        },
        {
            title: '操作',
            width: 140,
            align: 'center',
            render: (text, record, index) => (
                <>
                    <Button onClick={() => setEditCarVisible({ visible: true, value: { ...record } })}>
                        <FormOutlined style={{ cursor: 'pointer' }} />
                    </Button>
                    <Button onClick={() => onDelete([record])}>
                        <DeleteOutlined style={{ cursor: 'pointer' }} />
                    </Button>
                </>
            ),
        },
        {
            title: '路线名称',
            width: 120,
            align: 'center',
            dataIndex: 'lineName',
        },
        {
            title: '起点',
            width: 160,
            align: 'center',
            dataIndex: 'startingPoint',
        },
        {
            title: '途经点',
            width: 160,
            align: 'center',
            dataIndex: 'pathwayPoints',
        },
        {
            title: '终点',
            width: 160,
            align: 'center',
            dataIndex: 'endPoint',
        },
        {
            title: '备注',
            width: 160,
            align: 'center',
            dataIndex: 'note',
        },
        {
            title: '创建人',
            width: 200,
            align: 'center',
            dataIndex: 'createUser',
        },
    ]

    //点击行选高亮
    const onRow = (record: IRoutineDetail) => {
        let findObj = selectedRowKeys.find((item) => item.id === record.id)
        if (findObj) {
            let newSelectedRowKeys = selectedRowKeys.filter((item) => item.id !== record.id)
            setSelectedRowKeys(newSelectedRowKeys)
        } else {
            setSelectedRowKeys((origin) => [...origin, record])
        }
    }

    return (
        <Table
            rowKey={(record) => record?.id as string}
            loading={loading}
            rowSelection={{
                //全部选中时 (存row[])
                onSelectAll: (selected, selectedRows, changeRows) => {
                    selected
                        ? setSelectedRowKeys((origin) => [...origin, ...changeRows])
                        : setSelectedRowKeys((origin) => {
                              let changeRowId = changeRows.map((item) => item.id)
                              return origin.filter((item) => changeRowId.indexOf(item.id) < 0)
                          })
                },
                onSelect: (record, selected, selectedRows) => onRow(record),
                selectedRowKeys: selectedRowKeys.map((item) => item.id as string),
            }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                position: ['bottomRight'],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                },
                showSizeChanger: true,
            }}
            bordered
            onRow={(record) => ({
                onClick: () => onRow(record),
                onContextMenu: (e) => {
                    e.preventDefault()
                    setSelectedRowKeys([record])
                },
            })}
            scroll={{ x: 'max-content', y: 'calc(100vh - 350px)' }}
        />
    )
}
